module.exports = __webpack_public_path__ + "media/images/green_globe-93d0ce1b41f75da811b2a417404c8f87.png";